<template>
  <!-- Sticky Footer -->
  <footer class="sticky-footer">
    <section class="section-padding footer-list">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-3">
            <div class="footer-logo mb-4">
              <RouterLink
                class="logo"
                to="/"
              >
                <img
                  alt=""
                  src="@/assets/theme/img/logo.png"
                  class="img-fluid"
                >
              </RouterLink>
            </div>
            <p>86 Petersham town, New South wales Waedll Steet, Australia</p>
            <p class="mb-0">
              <a
                href="#"
                class="text-dark"
              >
                <i class="fas fa-mobile fa-fw" /> +61 525 240 310
              </a>
            </p>
            <p class="mb-0">
              <a
                href="#"
                class="text-dark"
              >
                <i class="fas fa-envelope fa-fw" /> iammadgui@gmail.com
              </a>
            </p>
            <p class="mb-0">
              <a
                href="#"
                class="text-dark"
              >
                <i class="fas fa-globe fa-fw" /> www.askbootstrap.com
              </a>
            </p>
          </div>
          <div class="col-lg-2 col-md-2">
            <h6 class="mb-4">
              Company
            </h6>
            <ul>
              <li>
                <a href="#">
                  About us
                </a>
              </li>
              <li>
                <a href="#">
                  Careers
                </a>
              </li>
              <li>
                <a href="#">
                  Legal
                </a>
              </li>
              <li>
                <a href="#">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#">
                  Privacy
                </a>
              </li>
              <li>
                <a href="#">
                  Terms
                </a>
              </li>
              <li>
                <a href="#">
                  Contact us
                </a>
              </li>
            </ul>
          </div>
          <div class="col-lg-2 col-md-2">
            <h6 class="mb-4">
              Features
            </h6>
            <ul>
              <li>
                <a href="#">
                  Retention
                </a>
              </li>
              <li>
                <a href="#">
                  People
                </a>
              </li>
              <li>
                <a href="#">
                  Messages
                </a>
              </li>
              <li>
                <a href="#">
                  Infrastructure
                </a>
              </li>
              <li>
                <a href="#">
                  Platform
                </a>
              </li>
              <li>
                <a href="#">
                  Funnels
                </a>
              </li>
              <li>
                <a href="#">
                  Live
                </a>
              </li>
            </ul>
          </div>
          <div class="col-lg-2 col-md-2">
            <h6 class="mb-4">
              Solutions
            </h6>
            <ul>
              <li>
                <a href="#">
                  Enterprise
                </a>
              </li>
              <li>
                <a href="#">
                  Financial Services
                </a>
              </li>
              <li>
                <a href="#">
                  Consumer Tech
                </a>
              </li>
              <li>
                <a href="#">
                  Entertainment
                </a>
              </li>
              <li>
                <a href="#">
                  Product
                </a>
              </li>
              <li>
                <a href="#">
                  Marketing
                </a>
              </li>
              <li>
                <a href="#">
                  Analytics
                </a>
              </li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-3">
            <h6 class="mb-4">
              NEWSLETTER
            </h6>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Email Address..."
              >
              <div class="input-group-append">
                <button
                  class="btn btn-primary"
                  type="button"
                >
                  <i class="fas fa-arrow-right" />
                </button>
              </div>
            </div>
            <small>It is a long established fact that a reader will be distracted by..</small>
            <h6 class="mb-2 mt-4">
              DOWNLOAD APP
            </h6>
            <div class="app">
              <a href="#">
                <img
                  alt=""
                  src="@/assets/theme/img/google.png"
                >
              </a>
              <a href="#">
                <img
                  alt=""
                  src="@/assets/theme/img/apple.png"
                >
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
export default {};
</script>
